// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + ({"182":"transfers","665":"voucher"}[chunkId] || chunkId) + "." + {"182":"1ecf3cab","665":"1ecf3cab","702":"b8cebe2f","790":"1ecf3cab","947":"2cb1bd09"}[chunkId] + ".css";
};